import { useZakelijkOrder } from "app/hooks/payment/useZakelijkOrder";
import { concatClassnames } from "shared/utils/concatClassnames";
import ZakelijkPaymentProductItemSidebar from "./ZakelijkPaymentProductItemSidebar";
import Skeleton from "react-loading-skeleton";

const ZakelijkPaymentSidebarProductsList = () => {
  const { products, isLoading } = useZakelijkOrder();

  if (isLoading) {
    return <Skeleton height={400} />;
  }
  return (
    <>
      {products.map((product, id) => {
        return (
          <div
            key={`product-${id}`}
            className={concatClassnames(
              "gg-grid gg-grid-cols-12 gg-items-start",
              id !== products.length - 1 && "gg-border-b",
              id !== 0 && "gg-pt-9",
              id !== products.length - 1 ? "gg-pb-9" : "gg-pb-2",
            )}
          >
            <ZakelijkPaymentProductItemSidebar product={product} />
          </div>
        );
      })}
    </>
  );
};
export default ZakelijkPaymentSidebarProductsList;
